import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-app-loader',
  templateUrl: './app-loader.component.html',
  styleUrls: ['./app-loader.component.css'],
  standalone: true,
  imports: [MatProgressSpinnerModule],
})
export class AppLoaderComponent {
  title;
  message;
  constructor(public dialogRef: MatDialogRef<AppLoaderComponent>) {}
}
